import React, { useState } from "react";
import {
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBInput,
  MDBBtn,
} from "mdbreact";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { SUBMIT, RESET } from "../../../services/redux/slices/marketing/feedback";

const COMMENT_MAX_LENGTH = 600;
const RATING_OPTIONS = [1, 2, 3, 4, 5];

const initialForm = {
  name: "",
  email: "",
  company: "",
  role: "",
  rating: 5,
  comment: "",
  consentToPublish: false,
};

export default function ShareFeedbackModal({ show, toggle }) {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const { formSubmitted } = useSelector(({ feedback }) => feedback);
  const [form, setForm] = useState(initialForm);

  const handleChange = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(SUBMIT({ data: form })).then((action) => {
      if (action.error) {
        addToast(
          action.payload || action.error.message || "Something went wrong.",
          { appearance: "error" }
        );
        return;
      }

      addToast("Thank you for sharing your feedback!", {
        appearance: "success",
      });
      setForm(initialForm);
      dispatch(RESET());
      toggle();
    });
  };

  return (
    <MDBModal isOpen={show} toggle={toggle} backdrop={true} cascading>
      <MDBModalHeader toggle={toggle}>Share Pilot Feedback</MDBModalHeader>
      <form onSubmit={handleSubmit}>
        <MDBModalBody>
          <p className="homePage-feedback-notice">
            Your feedback helps other healthcare teams learn about Pinoy iMD.
            Your name, role, and comment may be shown publicly only if you
            check "I agree to have my feedback published" below and our team
            approves it first. Your email is kept private and is never shown
            publicly.
          </p>
          <MDBInput
            label="Your name"
            value={form.name}
            onChange={handleChange("name")}
            required
          />
          <MDBInput
            label="Your email (kept private)"
            type="email"
            value={form.email}
            onChange={handleChange("email")}
            required
          />
          <MDBInput
            label="Company / Facility (optional)"
            value={form.company}
            onChange={handleChange("company")}
          />
          <MDBInput
            label="Role (optional)"
            value={form.role}
            onChange={handleChange("role")}
          />

          <div className="homePage-feedback-rating">
            <span>Rating:</span>
            {RATING_OPTIONS.map((value) => (
              <button
                type="button"
                key={value}
                className={`homePage-feedback-rating-star ${
                  form.rating >= value ? "active" : ""
                }`}
                onClick={() => setForm((prev) => ({ ...prev, rating: value }))}
                aria-label={`${value} star${value > 1 ? "s" : ""}`}
              >
                ★
              </button>
            ))}
          </div>

          <MDBInput
            label="Your feedback"
            type="textarea"
            rows={4}
            value={form.comment}
            onChange={handleChange("comment")}
            maxLength={COMMENT_MAX_LENGTH}
            required
          />
          <div className="homePage-feedback-charcount">
            {form.comment.length}/{COMMENT_MAX_LENGTH}
          </div>

          <MDBInput
            label="I agree to have my feedback (name, role, comment) published publicly once approved"
            type="checkbox"
            id="consentToPublish"
            checked={form.consentToPublish}
            onChange={(e) =>
              setForm((prev) => ({
                ...prev,
                consentToPublish: e.target.checked,
              }))
            }
          />
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="secondary" type="button" onClick={toggle}>
            Cancel
          </MDBBtn>
          <MDBBtn color="primary" type="submit" disabled={formSubmitted}>
            {formSubmitted ? "Sending..." : "Submit Feedback"}
          </MDBBtn>
        </MDBModalFooter>
      </form>
    </MDBModal>
  );
}
